export default __webpack_public_path__ + "static/media/filter_icon_accessibility_room_blue.1cb9f1f8.svg";